<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Campaign Master Steps</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button v-if="abilities.can('create', 'campaigns')"
            icon="add"
            @click="addSteps"
            color="danger"
            type="border"
            >Add</vs-button
          >
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
          <div class="p-1">
            <span>Search: </span>
          </div>

          <MasterStepsAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchSteps"
            :searchOn="'steps'"
            @event-name="handleChildEvent"
          ></MasterStepsAutocomplete>
          <vs-icon
            class="ml-5 pointer"
            icon="cancel"
            @click="resetAll"
            size="small"
          ></vs-icon>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
        

          <!-- <vs-pagination :total="Math.ceil(total/per_page)" v-model="currentx"></vs-pagination> -->
        </vs-col>
      </vs-row>
       <!-- <DataGrid :context="''" 
        ref="clientCampaignGrid"          
        :columnDefs="columnDefs"
        :rowData="steps"
          >
      </DataGrid> -->

      <vs-table
        class="mb-10"
        @search="handleSearch"
        @sort="handleSort"
        v-model="selected"
        stripe
        :data="steps"
      >
        <template slot="thead">
          <!-- <vs-th sort-key="s_no">S No.</vs-th> -->
          <vs-th sort-key="Steps">Steps</vs-th>
          <vs-th sort-key="Steps_description">Description</vs-th>
                    <vs-th sort-key="phase">Phase</vs-th>
          <vs-th sort-key="actions">Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="data[indextr]">
              {{ indextr + 1 }}
            </vs-td> -->
            <vs-td :data="data[indextr].steps">
              {{ data[indextr].steps }}
            </vs-td>
            <vs-td :data="data[indextr].description">
              {{ data[indextr].description }}
            </vs-td>
              <vs-td :data="data[indextr].phase">
              {{ data[indextr].phase }}
            </vs-td>
            <vs-td :data="data[indextr].actions">
              
              <vs-icon v-if="abilities.can('read', 'campaigns')"
                class="ml-10 removeButton"
                @click="viewSteps(data[indextr].id)"
                color="success"
                icon="visibility"
              ></vs-icon>
              <vs-icon v-if="abilities.can('update', 'campaigns')"
                class="ml-10 removeButton"
                @click="editSteps(data[indextr].id)"
                color="success"
                icon="edit"
              ></vs-icon>
              <vs-icon v-if="abilities.can('delete', 'campaigns')"
                class="ml-10 removeButton"
                @click="confirmDeleteSteps(data[indextr].id)"
                color="success"
                icon="delete"
              ></vs-icon>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <template>
        <vs-pagination
          :total="Math.ceil(total / per_page)"
          v-model="currentx"
        ></vs-pagination>
      </template>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleMasterStepsManagement from "@/store/campaign-management/master-steps-management/moduleMasterStepsManagement.js";
import MasterStepsAutocomplete from "@/components/autocomplete/MasterStepsAutocomplete.vue";
import vSelect from "vue-select";
import DataGrid from "@/components/aggrid/Aggrid.vue";
export default {
  data: () => ({
     columnDefs: [
      {
        headerName: "Steps",
        field: "steps",
        flex: 1,

        filter: "agMultiColumnFilter",
        // filterParams: {
        //   filters: [
        //     {
        //       filter: "agTextColumnFilter",
        //       display: "subMenu"
        //     },
        //     {
        //       filter: "agTextColumnFilter",
        //       display: "subMenu"
        //     },
        //     {
        //       filter: "agSetColumnFilter"
        //     }
        //   ]
        // }
      },
      {
        headerName: "Description",
        field: "description",
        filter: "agMultiColumnFilter",
        flex: 1
      },
      {
        headerName: "Phase",
        field: "phase",
        filter: "agMultiColumnFilter",
        flex: 1
      },
      {
        headerName: "Created At",
        field: "created_at",
        filter: "agDateColumnFilter",
        flex: 1
      },
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions"
      }
    ],
                            abilities : null,

    companySearchComponentKey: 0,
    selected: [],
    log: [],
    steps: [],
    selected_id: null,
    currentx: 1,
    total: 0,
    clientStepsList: ['y','n'],
    selected_steps: "All",
    size_per_page: [10, 20, 50, 100, 500],
    per_page: 10,
    paginationAttr: {
      page_no: 1,
      per_page: 10
    }
  }),
  components: {
    MasterStepsAutocomplete,
    "v-select": vSelect,
    moduleMasterStepsManagement,
    DataGrid
  },
  watch: {
    currentx: function(val) {
      this.paginationSetPageSize();
    },
    per_page: function(val) {
      this.paginationSetPageSize();
    },
     selected_client_Steps: function(val) {
          if(val != 'All')
      this.fetchStepsWithFilter();
    }
  },
  methods: {
    resetAll(){
       this.selected_client_Steps = 'All'
       this.resetSteps()

    },
    resetSteps() {
      this.fetchSteps();
      this.companySearchComponentKey += 1;
    },
    paginationSetPageSize() {
      this.paginationAttr = {
        page_no: this.currentx,
        per_page: this.per_page
      };
      this.fetchSteps();
    },
    searchSteps(inputValue) {
      return this.$store
        .dispatch("MasterStepsManagement/searchSteps", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].steps
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    addSteps() {
      this.$router.push({ path: "/campaigns/master-step/add" });
    },
    handleSearch(searching) {
      console.log(`The Steps searched for: ${searching}`);
    },
    handleSort(key, active) {
      console.log(`the Steps ordered: ${key} ${active}`);
    },
    viewSteps(id) {
      this.$router.replace("/campaigns/master-step/" + id);
    },
    editSteps(id) {
      this.$router.replace("/campaigns/master-step/edit/" + id);
    },
    handleChildEvent() {
      this.steps = moduleMasterStepsManagement.state.steps.datas;
    },
    confirmDeleteSteps(id) {
      this.selected_id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Delete Steps`,
        accept: this.deleteSteps,
        acceptText: "Delete"
      });
    },
    deleteSteps() {
      this.$store
        .dispatch("MasterStepsManagement/removeSteps", this.selected_id)
        .then(res => {
          if (res.data.status == "success") {
            this.fetchSteps();
            this.showDeleteSuccess();
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Steps Deleted",
        text: "The User was successfully deleted"
      });
    },
    fetchSteps() {
      this.$store
        .dispatch(
          "MasterStepsManagement/fetchAllMasterSteps",
          this.paginationAttr
        )
        .then(res => {
          console.log();
          this.steps =
            moduleMasterStepsManagement.state.steps.datas;
          this.total = moduleMasterStepsManagement.state.steps.total;
          this.per_page =
            moduleMasterStepsManagement.state.steps.per_page;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchStepsWithFilter() {
      let filter = {}
      filter.is_client_Steps = this.selected_client_Steps
      this.$store
        .dispatch(
          "MasterStepsManagement/fetchAllMasterStepsWithFilter",
          filter
        )
        .then(res => {
          this.Steps =
            moduleMasterStepsManagement.state.Steps;
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
    this.fetchSteps();
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
    if (!moduleMasterStepsManagement.isRegistered) {
      this.$store.registerModule(
        "MasterStepsManagement",
        moduleMasterStepsManagement
      );
      moduleMasterStepsManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Steps
  .con-btns-Steps
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Stepsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
